import React from "react";
import { useLang } from "../LangContext";

interface Props {
  className?: string;
}

export default function LangToggle({ className }: Props) {
  const { lang, setLang, t } = useLang();
  return (
    <button
      type="button"
      className={`theme-toggle lang-toggle${className ? ` ${className}` : ""}`}
      aria-label={lang === "de" ? t.switchToEnglish : t.switchToGerman}
      onClick={() => setLang(lang === "de" ? "en" : "de")}
    >
      {lang === "de" ? "EN" : "DE"}
    </button>
  );
}
